import api from "./api";

/* LOGIN */
export const loginUser = async (credentials) => {
  // HRMS backend uses 'email' and 'password' fields
  const payload = {
    email: credentials.email || credentials.username,
    password: credentials.password,
  };

  const response = await api.post("auth/login/", payload);

  // Response is wrapped: { success, data: { access, refresh, user } }
  const tokens = response.data.data || response.data;

  localStorage.setItem("accessToken", tokens.access);
  localStorage.setItem("refreshToken", tokens.refresh);

  // Fetch the full user profile immediately after getting the token
  try {
    const profileRes = await api.get("auth/profile/");
    const userData = profileRes.data.data || profileRes.data;
    localStorage.setItem("user", JSON.stringify(userData));
    return userData;
  } catch (err) {
    // Fallback to user data from token response
    const fallbackUser = tokens.user || { email: credentials.email || credentials.username };
    localStorage.setItem("user", JSON.stringify(fallbackUser));
    return fallbackUser;
  }
};

/* LOGOUT */
export const logoutUser = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    // Backend requires refresh token in body to blacklist it
    await api.post("auth/logout/", { refresh: refreshToken });
  } catch (err) {
    // Silently handle — we clear storage regardless
  }
  localStorage.clear();
};

/* FORGOT PASSWORD */
export const forgotPassword = async (email) => {
  const response = await api.post("auth/forgot-password/", { email });
  return response.data;
};

/* RESET PASSWORD */
export const resetPasswordApi = async (token, new_password, confirm_password) => {
  const response = await api.post("auth/reset-password/", {
    token,
    new_password,
    confirm_password,
  });
  return response.data;
};